import React from 'react';

import { ContactsInteractionListViewType } from 'constants/ui';

/**
 * Keeps track of the ContactsInteractionListViewType for the ContactsInteractionList component.
 * @type {import('react').Context}
 */
export default React.createContext(ContactsInteractionListViewType.FULL);
